import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import ToggleButton from "./ToggleButton";
import { FaEdit } from "react-icons/fa";

export default function ExpandableWithToggle({
  ControllerProps,
  currentSheet,
  dispatchItemToredux,
  defaultValue,
  componentType,
  customButtonState,
  aside3Title,
  showApplyBtn,
  expantion = false,
  setExpantion,
  children,
}) {
  // console.log(componentType);
  // console.log(expantion);
  const [toggleValue, setToggleValue] = useState(defaultValue || false);
  // console.log(toggleValue);  
  const { title, reduxKey } = ControllerProps !== undefined && ControllerProps;
  const [expanded, setExpanded] = useState(expantion);
  // console.log(expanded);
  const expandableRef = useRef(null);
  const handleClickOutside = (event) => {
    if (
      expandableRef.current &&
      !expandableRef.current.contains(event.target)
    ) {
      setExpanded(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setExpanded(expantion);
  }, [expantion]);
  const hanbdleToggleModal = () => {
    const modalState = !expanded;
    if (showApplyBtn) {
      setExpantion(modalState);
    } else {
      setExpanded(modalState);
    }
  };

  if (componentType === "CONTAINER_WITH_TOGGLE") {
    return (
      <div className={`ExpandableWithToggle w-full`}>
        <button
          className={`expandable-header cursor-pointer flex items-center justify-between h-auto w-full font-light border-b`}
          onClick={() => setExpanded(!expanded)}
        >
          <button
            className={`flex items-center justify-start ${
              toggleValue ? "relative -left-[0.6rem]" : ""
            }`}
          >
            {toggleValue ? (
              <span className="flex items-center">
                {expanded ? (
                  <MdKeyboardArrowDown className={`text-2xl text-gray-600`} />
                ) : (
                  <MdKeyboardArrowRight className={`text-2xl text-gray-600`} />
                )}
              </span>
            ) : null}
            <span className={`text-black font-light text-sm`}>{title}</span>
          </button>
          <ToggleButton
            defaultValue={defaultValue}
            dispatchItemToredux={dispatchItemToredux}
            setToggleValue={setToggleValue}
            reduxKey={reduxKey}
          />
        </button>
        {expanded && toggleValue ? (
          <div
            className={`expandable-content pt-1 relative w-full gap-y-1 flex flex-col`}
          >
            {children}
          </div>
        ) : null}
      </div>
    );
  }
  if (componentType === "CONTAINER_WITHOUT_TOGGLE") {
    return (
      <div className={`ExpandableWithToggle w-full`}>
        <button
          className={`expandable-header cursor-pointer flex items-center justify-between h-auto w-full font-light border-b`}
          onClick={() => setExpanded(!expanded)}
        >
          <button
            className={`flex items-center justify-start relative -left-[0.6rem]`}
          >
            <span className="flex items-center">
              {expanded ? (
                <MdKeyboardArrowDown className={`text-2xl text-gray-600`} />
              ) : (
                <MdKeyboardArrowRight className={`text-2xl text-gray-600`} />
              )}
            </span>
            <span className={`text-black font-light text-sm`}>{title}</span>
          </button>
        </button>
        {expanded ? (
          <div className={`expandable-content pt-1 relative w-full`}>
            {children}
          </div>
        ) : null}
      </div>
    );
  }
  if (componentType === "CONTAINER_WITH_CUSTOM_BUTTON") {
    return (
      <div className={`ExpandableWithToggle w-full`}>
        <button
          className={`expandable-header cursor-pointer flex items-center justify-between h-auto w-full font-light`}
          onClick={() => setExpanded(!expanded)}
        >
          <button
            className={`flex items-center justify-start relative -left-[0.6rem]`}
          >
            <span className="flex items-center">
              {expanded ? (
                <MdKeyboardArrowDown className={`text-2xl text-gray-600`} />
              ) : (
                <MdKeyboardArrowRight className={`text-2xl text-gray-600`} />
              )}
            </span>
            <span className={`text-black font-light text-sm`}>{title}</span>
          </button>
          <FaEdit
            className="cursor-pointer"
            onClick={() => customButtonState(true)}
          />
        </button>
        {expanded ? (
          <div className={`expandable-content pt-1 relative w-full`}>
            {children}
          </div>
        ) : null}
      </div>
    );
  }
  if (componentType === "ASIDE3FILTERS") {
    return (
      <div className={`ExpandableWithToggle w-full`}>
        <button
          className={`expandable-header cursor-pointer flex items-center justify-between h-auto w-full font-light`}
          onClick={hanbdleToggleModal}
        >
          <button
            className={`flex items-center justify-between border rounded w-full pl-1`}
          >
            <span className={`text-black font-light text-sm truncate`}>
              {aside3Title}
            </span>
            <span className="flex items-center">
              {expanded ? (
                <MdKeyboardArrowDown className={`text-2xl text-gray-600`} />
              ) : (
                <MdKeyboardArrowRight className={`text-2xl text-gray-600`} />
              )}
            </span>
          </button>
        </button>
        {expanded ? (
          <div className={`expandable-content pt-1 relative w-full`}>
            {children}
          </div>
        ) : null}
      </div>
    );
  }
}
